export function CRMCampaignStatsInfoBox({ name, value }) {
  return (
    <div
      className="crm-summary-box-subsection crm-summary-box-border"
      style={{ gap: 10, width: 320 }}
    >
      <div className="section-content-title">{name}</div>
      <div style={{ fontSize: 25, fontWeight: 500 }}>{value}</div>
    </div>
  );
}
